export const ASSET_EVENT_TIMEOUT_MS = 15_000;
